import { formatDateToBR } from './format-date-to-br'

export function getLast31DaysPeriod(): string {
  const today = new Date()
  const start = new Date(today)
  start.setDate(today.getDate() - 31)
  return `${formatDateToBR(start)} - ${formatDateToBR(today)}`
}
